import type { PropsWithChildren } from "react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { useModalData } from "@circle-react-uikit/ModalV2";
import { localeRoot } from "../../../constants";

interface HighlightRowProps {
  index: number;
  onClick: (inputIndex: number) => void;
}

const popperOptions = {
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 5],
      },
    },
  ],
};

export const HighlightRow = ({
  index,
  onClick,
}: PropsWithChildren<HighlightRowProps>) => {
  const { contentPortalElement } = useModalData();

  return (
    <div className="flex flex-row items-center justify-between">
      <Typography.LabelSm weight="medium">
        {t([localeRoot, "builder.price_callouts.fields.highlight_row"], {
          row_number: index + 1,
        })}
      </Typography.LabelSm>
      <Dropdown
        button={
          <div
            className={classNames(
              "hover:bg-tertiary flex h-6 w-6 justify-center rounded",
            )}
          >
            <Icon
              type="menu-dots"
              className="text-light"
              useWithFillCurrentColor
            />
          </div>
        }
        className={classNames("text-dark z-10 flex justify-end")}
        transitionWrapperClassName="z-50"
        buttonWrapperClassName="flex"
        popperOptions={popperOptions}
        appendTo={contentPortalElement ?? document.body}
      >
        <Dropdown.ItemWithLink onClick={() => onClick(index)}>
          <div className="flex flex-row items-center gap-x-2">
            <Icon
              type="16-star"
              useWithStrokeCurrentColor
              useWithFillCurrentColor
              viewBox="0 0 16 16"
            />
            <Typography.LabelSm weight="medium">
              {t("highlight")}
            </Typography.LabelSm>
          </div>
        </Dropdown.ItemWithLink>
      </Dropdown>
    </div>
  );
};
